// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__2TC4X","col":"styles_col__14bU7"};